import { createAsyncThunk } from "@reduxjs/toolkit";
import { DataService } from "../config/dataService/dataService";

export const fetchAllSetting = createAsyncThunk(
    "setting/fetch",
    async (filter, { rejectWithValue }) => {
        try {
            let url = '/setting'
            if (filter) {
                url += '?' + filter;
            }

            const response = await DataService.get(url);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }  
)

export const createNewSetting = createAsyncThunk(
    "setting/create",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await DataService.post('/setting', data);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }  
)

export const updateSetting = createAsyncThunk(
    "setting/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await DataService.patch('/setting/' + id, data);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }  
)

export const deleteSetting = createAsyncThunk(
    "setting/delete",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await DataService.delete('/setting/' + id);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }  
)